import pageHome from "./home";
import pageLogin from "./login";
import msg from "./msg";
import ic from "./icon";
import label from "./label";
export default {
  systemName: "Sinopデータレポートシステム",
  msg,
  button: {
    clear: "クリア",
    search: "検索",
    ok: "保存",
    download: "ダウンロード",
    upload: "アップロード",
    cancel: "キャンセル",
    save: "保存",
    back: "戻る",
    reject: "差し戻し",
    approve: "承認",
    notSave: "保存しない",
    filter: "フィルター",
    delete: "削除",
    detail: "詳細",
    export: "出力",
    exportContestant: "受験者リスト出力",
    exportResult: "試験結果出力",
    register: "登録",
    resetPassword: "パスワードリセット",
  },
  navBars: {
    profile: "プロフィール",
    changePassword: "パスワード変更",
    signOut: "ログアウト",
  },
  page403: {
    subject: "403 - アクセス拒否",
    description: "このページへのアクセスが許可されていません。",
  },
  page404: {
    subject: "404 - NOT FOUND",
    description: "お探しのページが見つかりません。",
  },
  tableText: {
    /*numberOfRecord: "ページあたりの行数",*/
    numberOfRecord: "レコード数",
    loadingText: "読み込み中。。。待って下さい。",
    noResultsText:
      "検索条件に該当するデータが見つかりません。検索条件を見直してください。",
    noDataText:
      "検索条件に該当するデータが見つかりません。検索条件を見直してください。",
  },
  vendor: "ベンダー",
  company: "グループ各社",
  all: "全て",
  activated: "有効",
  notActivated: "無効",
  searchCondition: "検索条件",
  required: "必須",
  optional: "－",
  pageLogin,
  pageHome,
  ic,
  label,
};
